import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, Cell, ResponsiveContainer,
} from 'recharts';
import { factorColor, formatFactor } from './chartUtils';
import type { BreakdownEmployee } from '~/common/api/zeiterfassungServerApi/ProjectRecordApi';
import useTranslate from '~/common/utils/translate';

interface Props {
  data: BreakdownEmployee[];
}

export const ProjectEmployeeFactorChart: React.FC<Props> = ({ data }) => {
  const t = useTranslate();
  // Same order as P1 (sorted by total_duration desc from backend)
  const chartData = data.map((e) => ({
    name: e.employee_name || `#${e.employee_id}`,
    factor: e.avg_factor_calculated,
  }));

  return (
    <Box bg="gray.50" border="1px solid" borderColor="gray.200" borderRadius="lg" p={3}>
      <Text fontSize="sm" fontWeight="600" mb={2}>
        {t('projectRecords.chart.employeeFactor')}
      </Text>
      <Box h="200px">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData}>
            <XAxis dataKey="name" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} />
            <Tooltip formatter={(value) => formatFactor(value as number)} />
            <Bar dataKey="factor" barSize={30}>
              {chartData.map((entry, i) => (
                <Cell key={i} fill={factorColor(entry.factor)} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};
